import _ from 'lodash';

const TOKEN_KEY = 'app_tokens';
const CORP_KEY = 'user_corps';
const LAYOUT_KEY = 'layout';

const storage = localStorage;

/**
 * 返回 tokens {access_token: string, refresh_token: string}
 *
 * @return {Object}
 */
export function getTokens() {
    const data = storage.getItem(TOKEN_KEY);
    return JSON.parse(data);
}

/**
 * 保存 tokens
 *
 * @param {Object} tokens {access_token: string, refresh_token: string}
 */
export function setTokens(tokens) {
    storage.setItem(TOKEN_KEY, JSON.stringify(tokens));
}

/**
 * 清除 tokens
 */
export function cleanTokens() {
    storage.removeItem(TOKEN_KEY);
}

export function setStorageCorps(currentCorpId, corps) {
    storage.setItem(CORP_KEY, JSON.stringify({cid: currentCorpId, corps}));
}

export function getStorageCorps() {
    return JSON.parse(storage.getItem(CORP_KEY));
}

/**
 * 插入样式风格
 */
export function changeLayout() {
    const layout = storage.getItem(LAYOUT_KEY);
    const flag = JSON.parse(layout).style;
    storage.setItem(LAYOUT_KEY, JSON.stringify({style: !flag}));
}

export function getLayout() {
    // if (_.isEmpty(storage.getItem(LAYOUT_KEY))) {
    //     storage.setItem(LAYOUT_KEY, JSON.stringify({style: false}));
        return true;
    // } else {
    //     const layout = JSON.parse(storage.getItem(LAYOUT_KEY)).style;
    //     return layout;
    // }
}

/**
 * 返回当前在用的企业 id
 * @return {string|*}
 */
export function getStorageCorpId() {
    const corps = getStorageCorps();
    return corps?.cid ?? null;
}

export function getStorageUserId() {
    const usercorps = getStorageCorps();
    const corpId = usercorps?.cid;
    if (!corpId) {
        return null;
    }

    const corps = usercorps?.corps;
    if (_.isEmpty(corps)) {
        return null;
    }

    const curCorp = corps.find(corp => corp.corpId === corpId);
    if (_.isEmpty(curCorp)) {
        return null;
    }
    return curCorp.userId;
}

export function clearStorageCorps() {
    storage.removeItem(CORP_KEY);
}
